(function(angular) {
  'use strict';

  angular.module('asSupplyMgr', ['osiAssets']);
})(window.angular);
